import React from "react";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <div className="container about">
      <h2 className="has-fade fade-in">О проекте</h2>
      <p className="has-fade fade-in">
        &emsp; Думая о городе, большинство людей представляет шумные улицы и
        знаковые достопримечательности. Хотя эти физические структуры,
        несомненно, важны для формирования идентичности города, в конечном итоге
        именно люди, их эмоции и воспоминания действительно оживляют город.
        Города — это не просто собрания бетона и стали, это живые, дышащие
        организмы, состоящие из разнообразных личностей с уникальными историями,
        прошлым и опытом. От художников и музыкантов, которые раскрашивают город
        цветом и звуком, до предпринимателей и новаторов, которые продвигают его
        экономику вперед.
      </p>
      <p className="has-fade fade-in">
        &emsp; Архитектура города может вызывать у жителей чувство общности и
        принадлежности. В конечном счете, именно симбиотические отношения между
        жителями города и его зданиями придают ему уникальный характер и
        очарование. Без людей, которые вдыхают жизнь в его улицы и пространства,
        город был бы просто набором пустых построек, лишенных смысла и цели.
      </p>
      <p className="has-fade fade-in">
        &emsp; Поэтому в следующий раз, когда вы окажетесь на улицах нашего
        города, найдите минутку, чтобы по-новому взглянуть на историю города,
        которую вы, возможно, не знали, здания и людей, которые называют его
        своим домом.
      </p>
      <Link to="/">
        <button className="button">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
            />
          </svg>
        </button>
      </Link>
    </div>
  );
};

export default About;
